import { lazy } from 'react';

export interface SectionConfig {
  key: string;
  PageComponent: React.LazyExoticComponent<React.ComponentType<any>>;
}

const CompSetsPage = lazy(() => import('pages/comp-sets/CompSetsPage'));
const AccountAccessPage = lazy(() => import('pages/account-access/AccountAccessPage'));
const ProgramAccessPage = lazy(() => import('pages/program-access/ProgramAccessPage'));
const ChangeLogPage = lazy(() => import('pages/change-log/ChangeLogPage'));
const MasterDataPage = lazy(() => import('pages/master-data/MasterDataPage'));

export const sections: SectionConfig[] = [
  { key: 'comp-sets', PageComponent: CompSetsPage },
  { key: 'data-access-control', PageComponent: AccountAccessPage },
  { key: 'program-access', PageComponent: ProgramAccessPage },
  { key: 'change-log', PageComponent: ChangeLogPage },
  { key: 'master-data', PageComponent: MasterDataPage },
];
